@if (lorenzFormControl && lorenzFormGroup) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			<input class="control"
				   type="text"
				   [ngClass]="{
						'readonly': lorenzFormControl.isBlocked(),
						'faulty': lorenzFormControl.isFaulty(),
						'missing-required': lorenzFormControl.isMissingRequiredValue(),
						'no-label': !lorenzFormControl.hasLabel(),
						'highlighted': lorenzFormControl.isHighlighted(),
					}"
				   [formControl]="lorenzFormControl"
				   [attr.placeholder]="placeholder"
				   [attr.readonly]="lorenzFormControl.isBlocked() ? true : null"
				   [attr.list]="defaultValues"
				   [attr.inputmode]="lorenzFormControl.payload.inputMode ?? null"
				   [attr.autocomplete]="lorenzFormControl.payload.autocomplete ?? null"
				   [attr.autocapitalize]="lorenzFormControl.payload.autocapitalize ?? null"
				   [attr.spellcheck]="lorenzFormControl.payload.spellcheck ?? null"
			>

			@if (hasLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
				<label class="floating-label"
					   [innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
				</label>
			}

			@if (lorenzFormControl.hasText()) {
				<div class="text"
					 [innerHTML]="lorenzFormControl.getText()">
				</div>
			}

			<lib-form-validity-dot [control]="lorenzFormControl" />

		</div>

		@if (lorenzFormControl.hasTextDefaults()) {

			<datalist id="defaultValues">

				@for (text of textDefaults; track $index) {
					<option>{{ text }}</option>
				}

			</datalist>

		}

		@if (showErrorMessages) {
			<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
		}

	</div>

}
